import * as S from './Table.styles';

export default S.Table;
